import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 py-8 px-6 mt-30">
      <div className="max-w-[1400px] mx-auto">
        {/* 상단 섹션: 로고와 네비게이션 */}
        <div className="flex flex-wrap gap-8 md:gap-12 pb-8  border-gray-200">
          {/* 왼쪽: 로고와 회사명 */}
          <div className="flex-shrink-0">
            <img
              src="/asset/footer_logo.png"
              alt="Aide logo"
              className="mb-2"
            />
          </div>

          {/* 중간: 네비게이션 컬럼들 */}
          <div className="flex flex-wrap gap-8 md:gap-12 flex-1">
            {/* Contact */}
            <div>
              <h3 className="text-sm font-semibold text-gray-400 mb-3">
                Contact
              </h3>
              <div className="space-y-2">
                <p className="text-sm text-gray-600">02) 6959-3214</p>
                <Link
                  to="/support"
                  className="text-sm text-gray-600 hover:text-gray-900 block"
                >
                  고객센터
                </Link>
              </div>
            </div>

            {/* Customer Support */}
            <div>
              <h3 className="text-sm font-semibold text-gray-400 mb-3">
                Customer Support
              </h3>
              <div className="space-y-2">
                <Link
                  to="/support/inquiry"
                  className="text-sm text-gray-600 hover:text-gray-900 block"
                >
                  문의하기
                </Link>
              </div>
            </div>

            {/* Family Site */}
            <div>
              <h3 className="text-sm font-semibold text-gray-400 mb-3">
                Family Site
              </h3>
              <div className="space-y-2">
                <a
                  href="http://n2ai.co.kr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-gray-900 block"
                >
                  N2AI
                </a>
                <a
                  href="https://www.meditong.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-gray-900 block"
                >
                  메디통
                </a>
              </div>
            </div>

            {/* Legal */}
            {/* <div>
              <h3 className="text-sm font-semibold text-gray-400 mb-3">
                Legal
              </h3>
              <div className="space-y-2">
                <a
                  href="#"
                  className="text-sm text-gray-600 hover:text-gray-900 block"
                >
                  서비스이용약관
                </a>
                <a
                  href="#"
                  className="text-sm text-gray-600 hover:text-gray-900 block"
                >
                  AI 서비스 정책
                </a>
              </div>
            </div> */}
          </div>
        </div>

        {/* 하단: 회사 정보 */}
        <div className="pt-6">
          <p className="text-xs text-gray-500 leading-relaxed break-keep">
            (07239) 서울 영등포구 여의서로 43 한서빌딩 403호 | 대표이사 : 조수민
            | 사업자등록번호 : 211-88-75827 | 법인명 : 엔투에이아이 주식회사 |
            개인정보관리책임자 : IT사업부 김용석 | 대표전화 : 02) 6959-3214 |
            팩스 : 02) 6499-1160 | 이메일: eun@eunkorea.com <br></br>ⓒ N2AI INC
            All rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
